import './timeseries_chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.UniqueUsersTimeseriesView extends Monitoring.Views.Charts.TimeseriesChartView
  valueField: 'count'
  chartOptions:
    yAxis:
      min: 0
    colors: []

  initialize: ->
    @title = I18n.t('monitoring.dashboard.charts.ugc_uniq')
    @title_en = I18n.t('monitoring.dashboard.charts.ugc_uniq', {'locale': 'en'})
    super
    @name = 'unique_users_time_series'

  addSeries: ->
    if @_dataIsEmpty()
      @$el.removeClass('processing')
    else
      @chartOptions.colors = []
      query = @searchQuery.deepCopy()
      query.set('interval', @intervalParam)
      query.set('dimension', 'unique_users')
      @_getUniqueUsers(query)
      return

  _dataIsEmpty: ->
    @facets['date'].count == 0

  _getUniqueUsers: (query) ->
    @ajaxCall("/monitoring/api/charts/unique_users/", query.toJSON(), (response) =>
      @date_from_realtime = response.date_from_realtime if response.date_from_realtime
      @date_to_realtime = response.date_to_realtime if response.date_to_realtime
      unique_users = []
      ugc = []
      _.each(response.values, (r) ->
        unique_users.push(r.unique_users)
        ugc.push(r.ugc)
      )
      @chartOptions.colors.push('#3498DB')
      @addSerie('Unique users', unique_users, 2)
    )
    @ajaxCall("/monitoring/dashboard/charts/tpm/", query.toJSON(), (response) =>
      @chartOptions.colors.push('#FFA500')
      @addSerie('UGC', response.values, 2)
    )
